export const TabBarConfigObject = [
    {
        id: 0,
        label: 'Cấu hình tham số'
    },
    {
        id: 1,
        label: 'Cấu hình vật thể'
    },
]

export const TabBarDefault = [
    {
        id: 0,
        label: 'Cấu hình tham số'
    }
]